// src/pages/product-module/CreateProduct.js

import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import DashboardWrapper from "../../components/DashboardWrapper";
import CrudForm from "../../components/dashboard/form/CrudForm";
import { useProductsCrud } from "../../hooks/useProductsCrud";
import productService from "../../services/productService";
import Breadcrumb from "../../components/Breadcrumbdashboard";

const generateSlug = (text) =>
  text.toString().toLowerCase().trim().replace(/\s+/g, "-");

export default function CreateProduct() {
  const navigate = useNavigate();

  const { createProduct } = useProductsCrud();

  // Local state for dropdowns
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [childCategories, setChildCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);

  // Load all dropdown options on mount
  // useEffect(() => { 
  //   const loadOptions = async () => {
  //     try {
  //       const [catRes, subCatRes, childCatRes, brandRes] = await Promise.all([
  //         productService.getAllCategories(),
  //         productService.getAllSubCategories(),
  //         productService.getAllChildCategories(),
  //         // productService.getAllBrands(),
  //       ]);

  //       setCategories(catRes.data?.data || catRes.data);
  //       setSubCategories(subCatRes.data?.data || subCatRes.data);
  //       setChildCategories(childCatRes.data?.data || childCatRes.data);
  //       // setBrands(brandRes.data?.data || brandRes.data);
  //     } catch (err) {
  //       Swal.fire("Error", "Failed to load dropdown options", "error");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   loadOptions();
  // }, []);
  useEffect(() => {
    const loadOptions = async () => {
      try {
        const [catRes, subCatRes, childCatRes ,brandRes] = await Promise.all([ 
          
          productService.getAllCategories(),
          productService.getAllSubCategories(),
          productService.getAllChildCategories(),
           productService.getAllBrands(),
        ]);
          const isActive = (item) => item.status === true || item.status === 1;

  let brandsData = brandRes.data?.data || brandRes.data || [];

brandsData = brandsData.filter(isActive);

setBrands(brandsData);
      

        // ✅ Get raw data
        let categoriesData = catRes.data?.data || catRes.data;
        let subCategoriesData = subCatRes.data?.data || subCatRes.data;
        let childCategoriesData = childCatRes.data?.data || childCatRes.data;

        // ✅ Step 1: Filter active
        categoriesData = categoriesData.filter(isActive);
        subCategoriesData = subCategoriesData.filter(isActive);
        childCategoriesData = childCategoriesData.filter(isActive);

        // ✅ Step 2: Maintain relation
        subCategoriesData = subCategoriesData.filter(sub =>
          categoriesData.some(cat => cat.id === sub.category_id)
        );

        childCategoriesData = childCategoriesData.filter(child =>
          subCategoriesData.some(sub => sub.id === child.sub_category_id)
        );

        // ✅ Set state
        setCategories(categoriesData);
        setSubCategories(subCategoriesData);
        setChildCategories(childCategoriesData);

        // ✅ Console (for verification)
        console.log("Categories:", categoriesData);
        console.log("SubCategories:", subCategoriesData);
        console.log("ChildCategories:", childCategoriesData);
console.log("brandRes:", brandRes);
      } catch (err) {
       Swal.fire({
  title: "Error",
  text: "Failed to load dropdown options",
  icon: "error",
  confirmButtonText: "OK",
  confirmButtonColor: "#FB6C22",
});

      } finally {
        setLoading(false);
      }
    };

    loadOptions();
  }, []);

  // Fields to render in the form
  const allowedFields = [
    "name",
    
    // "thumb_image",
    "images",
    // "category_id",
    "sub_category_id",
    "child_category_id",
    // "brand_id", 
    "qty",
    "short_description",
    "long_description",
    "video_link",
    "sku",
    "price",
    "offer_price",
    "offer_start_date",
    "offer_end_date",
    "product_type",
    // "status", 
   //"is_prescription",
    "seo_title",
    "seo_description",
    "colors"
  ];
const requiredFields = [
  "name",
  "images",
  "qty",
  "sku",
  "short_description",
  "long_description",
  "price",
];
const initialData = allowedFields.reduce((acc, field) => {
 // if (field === "status" || field === "is_prescription")
     if (field === "status")  {
    acc[field] = 1; // ✅ default Active  
  } else {
    acc[field] = "";
  }
  return acc;
}, {});

  const handleSubmit = useCallback(
    async (formData) => {
      try {
        const slug = generateSlug(formData.name);
        const payload = new FormData();

        Object.keys(formData).forEach((key) => {

          if (key === "images") {
            formData.images.forEach((img) => {
              payload.append("images[]", img);
            });

          } else if (key === "colors") {

            if (Array.isArray(formData.colors)) {
              formData.colors.forEach((color) => {
                payload.append("colors[]", color);
              });
            }

          } else {
            payload.append(key, formData[key]);
          }

        });
payload.append("is_approved", 0);
        payload.append("slug", slug);

        await createProduct(payload);
        Swal.fire({
          title: "Success",
          text: "Product created successfully!",
          icon: "success",
          confirmButtonText: "OK",
          confirmButtonColor: "#FB6C22",
        });
        navigate("/admin/all-products");
      } catch (error) {
        const errorMessage =
          error.response?.data?.errors
            ? Object.values(error.response.data.errors).flat().join(", ")
            : error.response?.data?.message || "Failed to create product";
        Swal.fire("Error", errorMessage, "error"); 
      }
    },
    [createProduct, navigate]
  );

  return (
    <DashboardWrapper>
      <div className="p-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
        <Breadcrumb/> 
       
        </div>

        <div className="row">
          <div className="col-12">
            <div className="card">

              {/* <h5 className="card-header">Create Product</h5>  */}
              <div className="card-body demo-vertical-spacing demo-only-element">
                {!loading ? (
                  <CrudForm
                    initialData={initialData}
                    onSubmit={handleSubmit}
                      requiredFields={requiredFields}

                    allowedFields={allowedFields}
                    fileUploadStyle="product"
                    
                    fileFields={[
                      { name: "images", multiple: true }
                    ]}
                    categories={categories}
                    subCategories={subCategories}
                    childCategories={childCategories}
                      brands={brands}
                  />
                ) : (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ minHeight: "200px" }}
                  >
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </DashboardWrapper>
  );
}
